import { State } from '../state.interface';

export const overridableEnabled = (state: State): boolean =>
  state.variableConfiguration.type === 'string' ? state.stringEditable : true;
